import apiClient from './client'

export interface SystemStats {
  cpu: {
    usage: number
    count: number
    model: string
  }
  memory: {
    total: number
    used: number
    free: number
    usagePercent: number
  }
  disk: {
    total: number
    used: number
    free: number
    usagePercent: number
  }
  process: {
    rss: number
    heapUsed: number
    heapTotal: number
    external: number
    arrayBuffers: number
  }
  uptime: number
  platform: string
  arch: string
}

export const systemApi = {
  getStats(): Promise<SystemStats> {
    return apiClient.post('/api/base/system/stats').then((res: any) => res.data.data)
  },
}

export interface FeatureFlags {
  creditEnable: boolean
  /** 是否启用手机号相关功能（后台开启「注册需填写手机号」时开启） */
  phoneEnable: boolean
}

/** 功能开关（公开接口，登录前/后均可访问） */
export const getFeatureFlags = async (): Promise<FeatureFlags> => {
  const resp = await apiClient.post('/api/system/feature', {})
  return resp.data.data
}
